import React from "react";
import { useReducer, useState, useRef } from "react";
import css from "./ResetPassword.module.scss";
import { NavLink,useNavigate } from "react-router-dom";
import { bg_reset_password } from "../../../Images";
import { DoResetPassword } from "../../../Services/AuthServices";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
const ChangePasswordPage = () => {
  const navigation = useNavigate();

  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  
  const [showPopup, setShowPopup] = useState(false);
  const [ErrorType, setErrorType] = useState(0);

  const {register, handleSubmit, watch, setValue, formState: { errors }, trigger} = useForm();
  const new_password = watch('new_password');



  const ResetPassword = async (data) => {
    try {
      const execute = await DoResetPassword(data);
      // console.log(execute.data.status)
      if (execute.data.status === 200) {
        setErrorType(execute.data.status)
        setShowPopup(true)
      }
    } catch (error) {
      console.log(error)
    }
  };

  // Call the doSendOtp function wherever you need to send the OTP
  const toggleShowPassword1 = () => {
    setShowPassword1(!showPassword1);
  };

  const toggleShowPassword2 = () => {
    setShowPassword2(!showPassword2);
  };
  useEffect(() => {
      setValue('email', localStorage.getItem("email_forgot"));
  }, []);

  return (
    <div
      className="backgrund-cover-no-repeat"
      style={{ backgroundImage: `url(${bg_reset_password})`,height:'100vh' }}
    >
      {showPopup && 
          <>
          {ErrorType === 200 &&  
            <div className={css.popup_wrap} onClick={() => navigation('/login')}>
              <div className={css.content_popup}>          
                <i class="fi fi-rr-cross-small" onClick={() => navigation('/login')}></i>
                <img src="/monitoring/assets/success.png" />
                <b>Successful!</b>
                <p>The password update was successful! You can now log in using your new password.</p>
              </div> 
            </div>
          }
          </>
      }
      <form onSubmit={handleSubmit(ResetPassword)}>
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3">
              <div className={css.header_dark}>
                <NavLink to="/verification">
                  <div className={css.back_button}>
                    <i class="fi-rr-arrow-small-left" />
                  </div>
                  <label>Reset Password</label>
                </NavLink>
              </div>
            </div>
          </div>
          
            <div className={css.wrap_form_login}>
              <div className="row pt-4">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3 text-center">
                  <div className={css.title}>Reset Password</div>
                </div>
              </div>
              <div className="row p-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3 pb-4 background-gray">
                  <label>Create New Password</label>
                  <input
                    type={showPassword1 ? "text" : "password"}
                    className={css.input_password}
                    placeholder="Enter Password"
                    
                    {...register('new_password', {
                      minLength: {
                        value: 8,
                        message: "Making sure it's at least 8 characters long."
                      },
                      pattern: {
                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_)])[A-Za-z\d@$!%*?&_]{8,}$/,
                        message: 'Password must contain mix of letters (both uppercase and lowercase), numbers, and special characters'
                      },
                      
                    })}
                    
                    onBlur={() => trigger('new_password')}
                  />
                  {showPassword1 ? (
                    <img
                      src="/monitoring/assets/Eye.svg"
                      className={css.eye_password}
                      onClick={toggleShowPassword1}
                    />
                  ) : (
                    <img
                      src="/monitoring/assets/EyeClose.svg"
                      className={css.eye_password}
                      onClick={toggleShowPassword1}
                    />
                  )}
                  
                  <div style={{ fontSize: 11, fontWeight: 400, color: '#FF8167', marginTop: 8 }}>
                    {errors.new_password && <p>{errors.new_password.message}</p>}
                  </div>
                  {/* <ul>
                    <li>New password must be different from current password.</li>
                    <li>
                      The password must contain mix of letters (both uppercase and
                      lowercase), numbers, and special characters.
                    </li>
                    <li>Making sure it's at least 8 characters long.</li>
                  </ul> */}

                  <label className="mt-3">Confirm New Password</label>
                  <input
                    type={showPassword2 ? "text" : "password"}
                    className={css.input_password}
                    placeholder="Enter Password"
                    
                    {...register('confirmNewPassword', {
                      validate: value =>
                        value === new_password || 'Password mismatch.',
                    })}
                    onBlur={() => trigger('confirmNewPassword')}

                  />
                  {showPassword2 ? (
                    <img
                      src="/monitoring/assets/Eye.svg"
                      className={css.eye_password}
                      onClick={toggleShowPassword2}
                    />
                  ) : (
                    <img
                      src="/monitoring/assets/EyeClose.svg"
                      className={css.eye_password}
                      onClick={toggleShowPassword2}
                    />
                  )}
                  
                  <div style={{ fontSize: 11, fontWeight: 400, color: '#FF8167', marginTop: 8 }}>
                    {errors.confirmNewPassword && <p>{errors.confirmNewPassword.message}</p>}
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div className={css.button_bottom_wrap}>
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <button>Update Password</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ChangePasswordPage;
